module.exports = __webpack_public_path__ + "static/media/temp_23.60b89915.jpg";